function Dot({ delay = 0 }: { delay?: number }) {
  return (
    <span
      className='inline-block h-2 w-2 rounded-full bg-white/90'
      style={{ animation: `typing-bounce 1s ${delay}ms infinite ease-in-out` }}
    />
  );
}

export function TypingDots() {
  return (
    <div className='flex items-center gap-1'>
      <Dot />
      <Dot delay={150} />
      <Dot delay={300} />
    </div>
  );
}

// Inject keyframes once for the typing animation
const styleEl =
  typeof document !== 'undefined' ? document.createElement('style') : null;
if (styleEl && !document.getElementById('typing-bounce-style')) {
  styleEl.id = 'typing-bounce-style';
  styleEl.innerHTML = `@keyframes typing-bounce {0%, 80%, 100% { transform: translateY(0); opacity: .7 } 40% { transform: translateY(-3px); opacity: 1 }}`;
  document.head.appendChild(styleEl);
}
